import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../styles/common/indicator.module.css'
import ProgLangList from '../common/ProgLangList'
import { selectMode, clearHistory, selectStep, updateOnEditId } from '../../actions/commonActions'
import { _MCO, _RECURRING_BILLING, _VAULTFINANCIAL, _VAULT } from '../../actions/types'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

export class Indicator extends Component {
    state = {
        visibleStepId: 1,
        isConfigOpen: false,
    };

    constructor(props) {
        super(props);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.state.isConfigOpen) {
            this.onCloseClick();
        }
    }

    isInteractive() {
        const { selection, selectedFeatureId } = this.props;
        if(selectedFeatureId === _RECURRING_BILLING){
            return (selection !== 1 && selection !== 4 && selection !== 5)
        }else{
            return false    
        }
        
    }

    onCloseClick() {
        this.props.updateOnEditId({featureId: this.props.selectedFeatureId, valueId: "none"});
        this.setState({ isConfigOpen: false});
    }

    renderMode() {
        const { selectedMode, notSelectedMode, switchContainer } = styles;
        const { mode, isInteractive } = this.props;

        if(isInteractive()) {
            return (
                <div className={switchContainer}>
                    <span className={mode === 'interactive_tool' ? notSelectedMode : selectedMode} onClick={() => mode === 'interactive_tool' ? this.props.selectMode('integration_guide') : null} style={{cursor: mode === 'interactive_tool' ? 'pointer' : 'default'}}>Integration Guide</span>
                    <span className={mode === 'interactive_tool' ? selectedMode : notSelectedMode} onClick={() => mode === 'integration_guide' ? this.props.selectMode('interactive_tool') : null} style={{cursor: mode === 'integration_guide' ? 'pointer' : 'default'}}>Interactive Tool</span>
                </div>
            );
        }
        else {
            return (
                <div className={switchContainer} style={{borderColor: '#999'}}>
                    <span className={selectedMode} style={{borderColor: '#999', backgroundColor: '#999', cursor: 'default'}}>Integration Guide</span>
                    <span className={notSelectedMode} style={{borderColor: '#999', cursor: 'default'}} >Interactive Tool</span>
                </div>
            );
        }
    }

    renderConfigTool() {
        const { selectedFeatureId, selectedStepId, mode } = this.props;

        if( this.props.isInteractive() && 
            mode === 'interactive_tool' && 
            !this.state.isConfigOpen && 
            !(selectedFeatureId === _MCO && [4, 5, 6].includes(selectedStepId))
            ) {
            if(isIE) {
                return (
                    <div className="tooltip" onClick={() => this.setState({ isConfigOpen: true })} style={{marginLeft: selectedFeatureId === _MCO ? '38%' : '50%', marginTop: "110px"}}>
                        <i className="material-icons">edit</i>
                        <span className="tooltiptext">Configuration</span>
                    </div>
                );
            }
            else {
                return (
                    <div className="tooltip" onClick={() => this.setState({ isConfigOpen: true })} style={{marginLeft: selectedFeatureId === _MCO ? '-25%' : '0'}}>
                        <i className="material-icons">edit</i>
                        <span className="tooltiptext">Configuration</span>
                    </div>
                );
            }
        }
        else {
            return null
        }
    }

    renderHistory() {
        const { circle, circleContainer, line, title, titleContainer, element } = styles;

        const { history, steps, selectedFeatureId } = this.props;
        var items = []
        var i = 0
        if( selectedFeatureId === _RECURRING_BILLING || 
            selectedFeatureId === _VAULT||
            selectedFeatureId === _VAULTFINANCIAL){
                return <div></div>
        }
        for(; i < history.length; ++i) {
            const stepId = steps[history[i] - 1].id;

            items.push(
                <div className={element}>
                    <div className={circleContainer} key={stepId}>
                        {
                            // eslint-disable-next-line
                            (() => {
                                if(i+1 !== history.length && history.length > 1) 
                                    return <span style={{marginLeft: isIE ? '1vw' : isSafari ? '6vw' : '12vw'}} className={line}></span>
                            })()
                        }
                        <span 
                            onClick={() => this.props.selectStep({featureId: selectedFeatureId, stepId})} 
                            className={circle}>
                        </span>
                    </div>

                    <div className={titleContainer} key={stepId}>
                        <span className={title}>{steps[stepId - 1].title}</span>
                    </div>
                </div>
            )
        }

        return items
    }

    render() {
        const {container, indicatorHeader, elementBar, sideConfigTitle, mainTitle, sideConfig, closebtn, clearHistory, border}  = styles;
        const { mode } = this.props;

        return (
            <div className={container} style={{position: mode === 'interactive_tool' ? 'relative' : 'fixed'}}>
                {this.renderConfigTool()}
                <div ref={this.wrapperRef} id="mysideConfig" className={sideConfig} style={{ overflowY: this.state.isConfigOpen ? 'auto' : 'hidden', width: this.state.isConfigOpen ? '300px' : '0px' }}>
                    <span style={{ marginTop: isIE ? '0px' : '1.6vh'}} className={closebtn} onClick={() => this.onCloseClick()}>&times;</span>
                    <h4 className={sideConfigTitle}>Configuration</h4>
                    {this.props.renderConfig()}
                </div>

                <div className={indicatorHeader}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',height: '11vh',marginLeft: '0.5vw' }}>
                        <span className={mainTitle}>{this.props.title}</span>
                        {this.renderMode()}
                    </div>

                    <span style={{height: '60px', width: '1px', backgroundColor: '#ccc', marginLeft: '2vw', marginRight: '0vw'}}></span>

                    <div className={elementBar}>
                        {this.renderHistory()}
                    </div>

                    {(() => {
                        if(this.props.history.length > 0 &&
                        (this.props.selectedFeatureId !== _RECURRING_BILLING &&
                        this.props.selectedFeatureId !== _VAULT &&
                        this.props.selectedFeatureId !== _VAULTFINANCIAL)) {
                            return (
                                <span className={clearHistory} onClick={() => this.props.clearHistory(this.props.selectedFeatureId)}>
                                    Clear History
                                </span>
                            )
                        }
                        else {
                            return (
                                <span className={clearHistory}></span>
                            )
                        }
                    })()}
                        
                    <span className={border} style={{height: '60px', width: '1px', backgroundColor: '#ccc', marginRight: '0.5vw', marginLeft: '0.5vw'}}></span>

                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                        <ProgLangList />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { mode, selectedFeatureId, selectedStepId } = state.common.sideNav;
    return { mode, selectedFeatureId, selectedStepId };
}

export default connect(mapStateToProps, {selectMode, clearHistory, selectStep, updateOnEditId})(Indicator)
